if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      const customProduct = this.form.closest(".main-single-product") || this.form.closest(".recharge-custom-action");
      const bundleProduct = this.form.closest(".addon-item") || this.form.closest(".landing-product-banner__content");

      if (customProduct) {
        const onetimeRadio = this.form.querySelector('input[type="radio"][data-radio-onetime][value="onetime"]:checked');
        const customVariantSelected = customProduct.querySelector(".custom-variant-label.is-active");

        if (onetimeRadio) {
          formData.delete('selling_plan');
          const firstOptionOneTime = this.form.closest("product-form")?.getAttribute("data-onetime-first");
          const secondOptionOneTime = this.form.closest("product-form")?.getAttribute("data-onetime-second");

          if (customVariantSelected && secondOptionOneTime) {
            formData.delete('id');
            formData.append('id', secondOptionOneTime);
          } else if (firstOptionOneTime && !customVariantSelected) {
            formData.delete('id');
            formData.append('id', firstOptionOneTime);
          }
        } else if (customVariantSelected) {
          const sellingPlanId = customVariantSelected.getAttribute('data-selling-plan-id');
          
          if (sellingPlanId && !bundleProduct) {
            formData.delete("selling_plan");
            formData.append("selling_plan", sellingPlanId);
          }
        }
      }

      if (bundleProduct) {
        const mainProductOnetimeRadio = document.querySelector('.main-single-product input[type="radio"][data-radio-onetime][value="onetime"]:checked');

        if (mainProductOnetimeRadio) {
          formData.delete("selling_plan");

          if (bundleProduct.hasAttribute('data-onetime-variant-id')) {
            const onetimeVariantId = bundleProduct.getAttribute('data-onetime-variant-id');
            if (onetimeVariantId) {
              formData.delete('id');
              formData.append('id', onetimeVariantId);
            }
          }
        }
      }

      const promoProduct = this.form.closest(".product-form._starter-pack");

      if (promoProduct) {
        formData.append('properties[_start_pack_promo]', 'true');
      }

      /* Collections All Products */
      if (customProduct) {
        const oneTimeOn = customProduct.hasAttribute('data-one-time') && customProduct.getAttribute('data-one-time') === 'true';
        const customVariantId = customProduct.hasAttribute('data-custom-variant') ? customProduct.getAttribute('data-custom-variant') : null;

        if (oneTimeOn) {
          formData.delete("selling_plan");
        }

        if (customVariantId) {
          formData.delete('id');
          formData.append('id', customVariantId);
        }
      }
      /* END Collections All Products */

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            if (this.cart && this.form.closest('.custom-products')) {
              window.location.reload();
            } else {
              this.cart.renderContents(response);
            }
          }

          window.dispatchEvent(new CustomEvent('custom:product-added-to-cart', {
            detail: {
              form: this.form,
              submitButton: this.submitButton,
              formData: Object.fromEntries(formData)
            }
          }));
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
